import { render, staticRenderFns } from "./ShowDiscussions.vue?vue&type=template&id=8df98af6&"
import script from "./ShowDiscussions.vue?vue&type=script&lang=js&"
export * from "./ShowDiscussions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports